import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {SharedCalendarViewConfig} from "@vesta/vos-types/modules/workspaceLevel/domain/SharedCalendarViewConfig";
import {sharedCalendarViewConfigValidator} from "@vesta/vos-types/modules/workspaceLevel/domain/SharedCalendarViewConfig";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type OttopilotBtlActivitiesWorkspaceCapabilityConfiguration = {
    lifecycleStageEventTemplateIds?: Array<Uuid>;
    eventStartBufferMs?: number;
    calendarConfig?: SharedCalendarViewConfig;
};

export const ottopilotBtlActivitiesWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotBtlActivitiesWorkspaceCapabilityConfiguration> = zod.strictObject({
    lifecycleStageEventTemplateIds: uuidZodValidator.array().optional(),
    eventStartBufferMs: zod.number().optional(),
    calendarConfig: sharedCalendarViewConfigValidator.optional(),
});
